<div class="wrapper">
    <app-navigation></app-navigation>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <app-header title="Agent Applications"></app-header>
        <app-agent-application-link></app-agent-application-link>

        <div class="container-fluid tab-pane custom-table">
            <br />
            <table class="tableData">
                <thead>
                    <tr>
                        <th>
                            <app-filter-arrow
                                filter="name"
                                title="NAME & SURNAME"
                                (filterValue)="receiveFilter($event)">
                            </app-filter-arrow>
                        </th>
                        <th>
                            <app-filter-arrow
                                filter="dateReceived"
                                title="DATE RECEIVED"
                                (filterValue)="receiveFilter($event)">
                            </app-filter-arrow>
                        </th>
                        <th>
                            <app-filter-arrow
                                filter="mobileNumber"
                                title="MOBILE NO."
                                (filterValue)="receiveFilter($event)">
                            </app-filter-arrow>
                        </th>
                        <th>
                            <app-filter-arrow
                                filter="location"
                                title="LOCATION"
                                (filterValue)="receiveFilter($event)">
                            </app-filter-arrow>
                        </th>
                        <th>
                            <app-filter-arrow
                                filter="denailReason"
                                title="REASON FOR DENIAL"
                                (filterValue)="receiveFilter($event)">
                            </app-filter-arrow>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="tablebox" *ngFor="let application of applicationList">
                        <td>
                            <img
                                class="table-user-img"
                                alt="Profile"
                                src="{{
                                    application?.profilePicture || 'assets/images/placeholder.png'
                                }}" />
                            <span>{{ application.fullName }}</span>
                        </td>
                        <td>
                            {{
                                application.dateReceived
                                    ? (application.dateReceived | date: 'mediumDate')
                                    : '-'
                            }}
                        </td>
                        <td>{{ application.mobileNumber }}</td>
                        <td>
                            <span
                                data-toggle="tooltip"
                                data-placement="right"
                                [attr.title]="application?.address?.formattedAddress || '-'">
                                {{ application?.address?.provinceName || '-' }}
                            </span>
                        </td>
                        <td>
                            {{ application.agentStatusMessage || '-' }}
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="pagination.showPagination()">
                    <tr>
                        <td>
                            Rows per page:
                            <span
                                ><b>{{ pagination.length }}</b></span
                            >
                            <app-page-length-dropdown (emitLength)="changeLength($event)">
                            </app-page-length-dropdown>
                        </td>
                        <td>
                            <app-page-navigation
                                pageNumber="{{ pagination.getPageNo() }}"
                                totalPages="{{ pagination.getTotalPages() }}"
                                (changePage)="changePage($event)">
                            </app-page-navigation>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <div class="control-sidebar-bg"></div>
</div>
